import { useState } from "react";
import { faqItems } from "@/mocks/navData";

export default function Faq() {
  const [open, setOpen] = useState(0);

  return (
    <section id="faq" className="scroll-mt-20">
      <div className="mx-auto w-full max-w-[1240px] px-4 py-14 md:px-6 md:py-20">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-[minmax(0,340px)_minmax(0,1fr)] lg:gap-16">
          <div className="lg:sticky lg:top-28">
            <span className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.22em] text-[#b0843f]">
              <i className="ri-question-line text-sm"></i>
              常见问题
            </span>
            <h2 className="mt-4 text-3xl font-bold leading-tight text-[#2a2016] md:text-4xl">
              还有疑问？先看这里
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-[#6b5d48]">
              关于直达入口、短链方式和更新节奏，下面挑重点讲清楚。
              没提到的，也欢迎按编号找对应分区里再对一遍。
            </p>
          </div>

          <div className="flex flex-col gap-3">
            {faqItems.map((item, i) => {
              const isOpen = open === i;
              return (
                <div
                  key={item.q}
                  className="overflow-hidden rounded-2xl border border-[#ead9bd] bg-[#fffdf8]"
                >
                  <button
                    type="button"
                    onClick={() => setOpen(isOpen ? -1 : i)}
                    className="flex w-full cursor-pointer items-center justify-between gap-4 px-6 py-5 text-left"
                  >
                    <span className="text-[15px] font-semibold text-[#2a2016]">{item.q}</span>
                    <span
                      className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full transition-colors ${
                        isOpen ? "bg-[#e4562b] text-white" : "bg-[#f0e3cd] text-[#b0843f]"
                      }`}
                    >
                      <i
                        className={`ri-add-line text-lg transition-transform duration-300 ${
                          isOpen ? "rotate-45" : ""
                        }`}
                      ></i>
                    </span>
                  </button>
                  <div
                    className={`grid transition-all duration-300 ${
                      isOpen ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
                    }`}
                  >
                    <div className="overflow-hidden">
                      <p className="px-6 pb-6 text-sm leading-relaxed text-[#6b5d48]">{item.a}</p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}